import { Grid, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

type FooterItem = { title: string; url: string };

const Pages = () => {
  const { t } = useTranslation("", { keyPrefix: "Footer.Pages" });
  const footerItems: FooterItem[] = t("items", { returnObjects: true });

  const clickHandler = (url: string) => {
    ReactGA.event({
      category: "Button",
      action: url,
      label: "Bookmark",
    });
  };

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mb: 2 }}>
          {t("title")}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List>
          {footerItems.map(({ title, url }: FooterItem, index) => (
            <ListItem disablePadding key={title}>
              <ListItemButton
                onClick={() => clickHandler(url)}
                href={url}
                disableGutters
                disableRipple
                divider={index !== footerItems.length - 1}
                target={title === "FAQs" ? "_blank" : undefined}
              >
                <KeyboardArrowRightIcon />
                <ListItemText primary={title} primaryTypographyProps={{ fontSize: "0.9rem" }} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Grid>
    </>
  );
};

export default Pages;
